import React from 'react';
import TableRow from '@material-ui/core/TableRow';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import Table from '@/modules/common/components/Table';
import HistoryType from '@/modules/common/components/HistoryType';
import TableContainer from '@/modules/common/components/TableContainer';
import { formatDateTime } from '~/common';
import Changes from './Changes';

const Component = ({history}) => {
    // noinspection JSUnresolvedVariable
    return (
        <TableContainer responsive={true}>
            <Table>
                <TableHead><TableRow>
                    {/*<TableCell className="history_id">ID</TableCell>*/}
                    <TableCell className="history_date">Дата/Время</TableCell>
                    <TableCell className="history_type">Действие</TableCell>
                    <TableCell className="history_changes">Измененные поля</TableCell>
                </TableRow></TableHead>
                <TableBody>
                    {history.map((element) => (
                        <TableRow key={element.history_id}>
                            {/*<TableCell className="history_id">{element.history_id}</TableCell>*/}
                            <TableCell className="history_date">
                                {formatDateTime(new Date(element.history_date))}
                            </TableCell>
                            <HistoryType type={element.history_type} changes={element.history_changes}>
                                <TableCell className="history_type">{element.history_type}</TableCell>
                            </HistoryType>
                            <TableCell className="history_changes">
                                {(element.history_changes)
                                    ? <Changes changes={element.history_changes}/>
                                    : null
                                }
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default Component;
